var _linearGradient, _linearGradient2, _linearGradient3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImageTitleBg = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 171,
    viewBox: "0 0 1440 171",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "1kn4ghqlpb",
    x1: 0.974,
    y1: 0.055,
    x2: 0.064,
    y2: 0.968,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dedede"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3z3kqiodod",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fadc3a"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "54q07ma4xe",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffeb5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#ffec74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd0"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "2ljtzgtfea"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5610",
    transform: "translate(0 67)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h1440v171H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rqabe9bhtc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 263",
    transform: "translate(237 -3)",
    style: {
      stroke: "#707070",
      fill: "#fff"
    },
    d: "M0 0h1144v341H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 456",
    transform: "translate(0 -67)",
    style: {
      clipPath: "url(#2ljtzgtfea)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2372"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 245",
    style: {
      fill: "url(#1kn4ghqlpb)"
    },
    d: "M0 0h1440v338H0z",
    transform: "translate(0 -100)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7",
    style: {
      clipPath: "url(#rqabe9bhtc)"
    },
    transform: "translate(0 -100)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3271",
    d: "M152.595 0A152.6 152.6 0 0 1 305.19 152.595V429.26a152.595 152.595 0 1 1-305.19 0V152.595A152.6 152.6 0 0 1 152.595 0z",
    transform: "rotate(-55 401.946 -160.959)",
    style: {
      opacity: 0.398,
      fill: "url(#3z3kqiodod)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 157",
    d: "M206 0h99.19v517.648a206 206 0 0 1-206 206H0V206A206 206 0 0 1 206 0z",
    transform: "rotate(-146 491.263 185.117)",
    style: {
      fill: "url(#54q07ma4xe)"
    }
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImageTitleBg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/image-titleBg.66cc7d501e65867096de8d2c69cb7da2.svg";